import { updateModuleCache } from '@/store/sync/cachingUtils';

import moduleIndex from './index.js';
export default {
  countItems({ news, labels, labelsById }) {
    const unreadCountsByInstance = {};

    // Reset label counters
    labels.forEach((label) => (label._usageCount = 0));

    // Count unread items per instance
    news.forEach((newsItem) => {
      if (!newsItem._userState) {
        console.debug('------------------ ATTENTION', newsItem);
      }
      if (newsItem._userState && !newsItem._userState.dateread) {
        // increase counter
        let unreadCount = unreadCountsByInstance[newsItem.instance];
        if (!unreadCount) {
          unreadCount = 0;
        }
        unreadCount++;
        unreadCountsByInstance[newsItem.instance] = unreadCount;
      }

      // Count usage of labels
      if (newsItem._labels) {
        newsItem._labels.forEach((referencedLabel) => {
          const label = labelsById[referencedLabel.labelIdFk];
          if (label) label._usageCount++;
        });
      }
    });
    return unreadCountsByInstance;
  },

  /**
   * Updates the module cache with data in the same structure as received by the module sync service.
   * @param state
   */
  async updateModuleCache(state) {
    const { news, labels, labelsNewsMapping, medias } = state;
    await updateModuleCache(moduleIndex.api, { news, labels, labelsNewsMapping, medias });
  },
};
